import { Injectable } from "@angular/core";
import { IHotjarAnalyticsConfig } from '@signature-it/ngx-generic/interfaces';
import { AbstractTracker } from '@signature-it/ngx-generic/classes';

declare let _: any;
declare let hj: any;

@Injectable()
export class HotjarAnalyticsService extends AbstractTracker {
    readonly ATTR_TRACKER_NAME: string = "hotjarAnalytics";

    protected _config: IHotjarAnalyticsConfig;

    /**
     * @whatItDoes Add Hotjar Analytics script to <head>
     * @param any config Optional
     */
    create(config: any) {
        this._config = config;
        this._appendScripts(document.head);
        return this;
    }

    protected _sendPageView(path: string): void {
        if(typeof hj !== "undefined") {
            hj('stateChange', path || "");
        } else {
            console.log("hj function isn't defined. Hotjar tracker doesn't triggered pageviews");
        }
    }

    protected _appendScripts(whereEl: HTMLElement): void  {
        if(this._hasTrackingId()) {
            let hjSettings = JSON.stringify({
                hjid: this._config.hjid,
                hjsv: this._config.hjsv
            });
            const scripthj = document.createElement('script');
            // Hotjar Tracking Code for http://fe.sales.parks.org.il/
            scripthj.innerHTML = `(function(h,o,t,j,a,r){
                                  h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
                                  h._hjSettings=${hjSettings};
                                  a=o.getElementsByTagName('head')[0];
                                  r=o.createElement('script');r.async=1;
                                  r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
                                  a.appendChild(r);
                              })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`;
            whereEl.appendChild(scripthj);
        }
    }

    protected _hasTrackingId(): boolean {
        return !_.isEmpty(this._config) && Number(this._config.hjid) > 0;
    }

}
